import React from 'react';
import useFeatureSetStyles from '~app/pages/Pricing/components/FeatureSet/useStyles';
import { SummaryDisplayFeatureList, DisplayFeatureStatic } from '~pricing/lib/summaryPackages';
import FeatureTooltip from '~pricing/components/Tooltip';

export default function FeatureSet({
  features,
  packageName,
}: {
  features: SummaryDisplayFeatureList;
  packageName: string;
}): React.ReactElement {
  const { Features, FeatureItem, FeatureSummary, TooltipContainer } = useFeatureSetStyles();

  return (
    <ul className={Features}>
      {features
        .filter((feature: DisplayFeatureStatic) => !!feature)
        .map((feature: DisplayFeatureStatic) => {
          return (
            <li className={FeatureItem} key={`${packageName}-feature-${feature?.summary}`}>
              {feature?.summary && (
                <span className={FeatureSummary}>
                  {feature?.summary}
                  {feature?.tooltip && feature?.tooltipHeading && (
                    <span className={TooltipContainer}>
                      <FeatureTooltip tooltipHeading={feature.tooltipHeading} tooltip={feature.tooltip} />
                    </span>
                  )}
                </span>
              )}
            </li>
          );
        })}
    </ul>
  );
}
